import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import {
  SupplierDeliveryNoteListDto,
  SupplierDeliveryNoteService,
} from '@digiwall/goliath-documents/proxy';
import { DwGridDataSourceService, FieldTypes } from '@digiwall/ag-grid';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService, SubscriptionService, LocalizationModule } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { ColDef } from '@ag-grid-community/core';
import { ListPageComponent } from '@digiwall/ag-grid';
import { AgGridComponent } from '@digiwall/ag-grid';
import { BaseSupplierDocList } from '../../base-supplier-docs/base-supplier-doc-list';

@Component({
  selector: 'document-supplier-delivery-note-list',
  templateUrl: './supplier-delivery-note-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: [DwGridDataSourceService, SubscriptionService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class SupplierDeliveryNoteListComponent
  extends BaseSupplierDocList<SupplierDeliveryNoteListDto, SupplierDeliveryNoteService>
  implements OnInit
{
  private _columns: ColDef[] = [
    ...this.colDefs,
    {
      field: 'receivedDate',
      headerName: this.localizationService.instant('Doc::SupplierDeliveryNote:ReceivedDate'),
      type: FieldTypes.Date,
    },
    {
      field: 'additionalCostPricePercentage',
      headerName: this.localizationService.instant(
        'Doc::SupplierDeliveryNote:AdditionalCostPricePercentage',
      ),
      type: FieldTypes.Percentage,
    },
    {
      field: 'warehouseCode',
      headerName: this.localizationService.instant('Doc::SupplierDeliveryNote:Warehouse'),
      type: FieldTypes.String,
    },
    {
      field: 'isStockValidated',
      headerName: this.localizationService.instant('Doc::SupplierDeliveryNote:IsValidated'),
      type: FieldTypes.Boolean,
      hide: true,
    },
  ];

  get columns(): ColDef[] {
    return this._columns;
  }

  constructor(
    supplierDeliveryNoteService: SupplierDeliveryNoteService,
    router: Router,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    confirmation: ConfirmationService,
    datasource: DwGridDataSourceService,
    injector: Injector,
  ) {
    super(
      supplierDeliveryNoteService,
      router,
      route,
      confirmation,
      localizationService,
      subscriptionService,
      datasource,
      injector,
    );
  }
}
